<template>
  <!-- this is an example of a dynamic template. -->
  <!-- Your dynamic content is exposed as 'content' data property in the template. -->
  <div class="smile-page">
    <div class="container">
      <div class="clearfix">
        <div class="">
          <div v-if="!currentContent">
            <div class="body">Loading...</div>
          </div>
          <div v-else >
           <div class="smile-section" >
              <div class="page-intro-image" v-if="item.IntroImage">
                <img :src="item.IntroImage" :alt='item.Title + "Intro Image"'/>
              </div>
              <div :class="route + ' section-section'">
                <h1 v-if="item.Title">{{item.Title}}</h1>
              </div>
              <div class="page-intro-text"  v-if="item.IntroText">
                <p>{{item.IntroText}}</p>
              </div>
              <div class="smile-content-image">
                <content-image :src="item.Image" :fieldClass="'responsive-image'"/>
              </div>
            </div>
            <div class="page-content-container">
              <div class="page-content">
                <content-body v-if="item.PageContent" :fieldClass="'body'" :body="item.PageContent"/>
              </div>  
              <iframe class="facebook-iframe" src="https://www.facebook.com/plugins/page.php?href=https%3A%2F%2Fwww.facebook.com%2FGirlGuidingStoneOutwardDivision&tabs=timeline&width=320&height=600&small_header=false&adapt_container_width=true&hide_cover=false&show_facepile=false&appId=92758718072" width="500" height="600" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowTransparency="true" allow="encrypted-media"></iframe>          
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LoadContent from './LoadContent'
import Title from '@/app/fieldTemplates/Title.vue'
import Image from '@/app/fieldTemplates/Image.vue'
import Body from '@/app/fieldTemplates/Body.vue'
import _ from 'lodash'

export default {
  mixins: [LoadContent],
  components: {
    contentTitle: Title,
    contentImage: Image,
    contentBody: Body
  },
  data() {
    return {
      item:{
        IntroImage: '',
        IntroText: '',
        PageContent: '',
        Title: ''
      },
      route: '',
      contact:false
    }
  },
  mounted() {},
  computed: {
    currentContent () {
      for(var i = 0; i < this.content.length; i++)
      {
        if(this.$route.path === '/'+this.content[i].slug)
        {
          this.item = this.content[i];
          this.route = this.content[i].slug
          console.log(this.item);
          if(this.$route.path === '/contact-us')
          {
            this.contact = true;
          }
          console.log(this.contact);
        }
      }
      return this.content;
    }
  },
  methods: {
   
  }
}
</script>

<style lang="scss">
@import '@/app/styles/index.scss';
.about{
  background-color:$color-blue !important;
}
.page-news {
  .news-title {
    margin-bottom: 5px;
  }
  .date {
    margin-bottom: 20px;
  }
  .subheadline {
    font-weight: 700;
    margin-bottom: 25px;
  }
  hr {
    margin: 30px 0 15px 0;
  }
  .share-box {
    .is-subheading {
      font-size: 20px;
    }
    ul {
      display: flex;
      margin-top: 10px;
      li {
        display: inline-block;
        margin-right: 20px;
      }
    }
  }
  .search-box {
    margin-bottom: 25px;
  }
}

@media (max-width: 768px) {
  .page-news {
    .rightbar {
      display: none;
    }
  }
}

@media (max-width: 600px) {
  .page-news {
    .search-box {
      margin: 10px 0;
      display: none;
    }
    .leftbar {
      margin-top: 10px;
    }
  }
}

.page-intro-text{
  padding: 30px;
  text-align: center;
  font-size:20px;
}
.page-image{
  max-width: 500px;
  margin: auto;
}
.page-content{
  margin: auto;
  padding-bottom: 20px;
  // flex:1 1 20px;
}
.page-content-container{
  display:flex;
  flex-direction:row;
  flex-wrap:wrap;
  padding:10px;
}
.facebook-iframe{
  // flex:1 1 20px;
  max-width:320px;
  margin:0 auto;
}
@media (min-width: 700px) {
  .page-content{
    padding-right: 20px;
    flex:1 1 20px;
  }
  .page-content-container{
    padding:40px;
  }
}
.smile-section{
  display:flex;
  flex-direction:column;
  flex-wrap:wrap;
  div{
    width:100%;
    max-width:1440px;
    margin: 0 auto;
  }
  .smile-content-image{
    width:100%;
    max-width:1000px;
    max-height: 500px;
    overflow: hidden;
  }
}
.page-intro-image{
      height: auto;
    max-width: 1000px;
  // flex: 1 1 20em;
    height: auto;
    // max-width: 500px;
    margin: auto;
    img{
      width: 100%;
      display:flex;
    }
}

.section-section {
    background-color:$color-smile-green;
  padding:30px;
  color:white;
  // flex: 2 2 20em;
  // display: flex;
  //   flex-direction: column;
  //   justify-content: center;
    h1{
      color:white;
      padding:20px;
      text-align:center;
      font-size:35px;
      font-weight:600;
      margin:0;
    }
}
.cards{
  width: 100%;
  max-width: 1200px;
  margin: auto;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content:center;
  align-items:stretch;
}

/**.card styling */
.card{
  flex: 2 2 20em;
  margin: 10px;
  // padding: 20px;
  width: auto;
  // max-width: 900px;
  text-align: center;
  height: auto;
  border-radius: 10px;
  flex-grow: 1;
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
.card h2{
  color:#4e88c7;
  padding:20px 10px;
  font-size: 28px;
  font-weight: 600;
}
.card p {
  margin: auto;
  padding: 20px 30px;
}
.card a {
  margin:10px;
  border:solid 2px white;
  background-color:$color-pink;
  color:white;
  padding: 10px;
  border-radius: 10px;
  display:inline-block;
}
</style>
